export default __webpack_public_path__ + "static/media/OtherServices1.86183aee.jpg";